<a
	ngbDropdown
	[href]="infoletterUrl"
	target="_blank"
	rel="noreferrer"
	class="btn toggle-dropdown p-0 border-0"
	#infoletterDropdown="ngbDropdown"
	placement="bottom-right"
	dropdownClass="dropdown-zindex"
	[container]="'body'"
	(mouseenter)="onHoverDropdown()"
	(mouseleave)="onLeaveDropdown()">
	<div
		ngbDropdownToggle
		id="infoletter-dropdown"
		role="button"
		[class.mobile-button]="!showLabel()"
		class="btn btn-outline-primary button-rounded d-flex gap-2 align-items-center justify-content-center position-relative">
		<img
			src="/assets/orca/header/infoletter.svg"
			loading="eager"
			class="infoletter-icon"
			decoding="async"
			[class.position-absolute]="!showLabel()"
			alt="infoletter-icon" />
		@if (showLabel()) {
			<span>{{ 'global.infoletter.title' | translate }}</span>
		}
	</div>

	<div id="infoletterDropdown" ngbDropdownMenu (mouseenter)="onHoverDropdown()" (mouseleave)="onLeaveDropdown()">
		<div class="w-100 px-4 pt-3 pb-3 d-flex flex-column align-items-center bg-gray-200" style="max-width: 31rem">
			<div class="h5 text-center" style="line-height: 1.5rem">
				{{ 'infoletter-header.title' | translate }}
			</div>
			<div class="text-center">
				<span>{{ 'infoletter-header.description' | translate }}</span>
			</div>
		</div>
	</div>
</a>
